import { render } from "./DialogInvalidFrameInInterval.vue?vue&type=template&id=4c66798c"
import script from "./DialogInvalidFrameInInterval.vue?vue&type=script&lang=js"
export * from "./DialogInvalidFrameInInterval.vue?vue&type=script&lang=js"
script.render = render

export default script